var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJobCreated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1667 15.0165H2.16667V4.83317H8V3.1665H2.16667C1.25 3.1665 0.5 3.9165 0.5 4.83317V14.8332C0.5 15.7498 1.25 16.4998 2.16667 16.4998H12.1667C13.0833 16.4998 13.8333 15.7498 13.8333 14.8332V8.99984H12.1667V15.0165Z",
    fill: "#248EB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8334 0.666504H12.1667V3.1665H9.66675C9.67508 3.17484 9.66675 4.83317 9.66675 4.83317H12.1667V7.32484C12.1751 7.33317 13.8334 7.32484 13.8334 7.32484V4.83317H16.3334V3.1665H13.8334V0.666504Z",
    fill: "#248EB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 6.5H3.83325V8.16667H10.4999V6.5Z",
    fill: "#248EB4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83325 9V10.6667H10.4999V9H7.99992H3.83325Z",
    fill: "#248EB4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 11.5H3.83325V13.1667H10.4999V11.5Z",
    fill: "#248EB4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobCreated);
export default __webpack_public_path__ + "static/media/job-created.9ae6a4d3f45e6e811e9c3e91b9cf57c6.svg";
export { ForwardRef as ReactComponent };